import { parseCodeReviewerSettingValue } from '../../utils';

import { CodeReviewerSettingToggle } from './code-reviewer-setting-toggle';

type OrganisationToggleProps = {
	org: GH.Organisation;
	onToggle?: (newValue: boolean) => void;
};
export const OrganisationToggle = ({ org, onToggle }: OrganisationToggleProps) => {
	const setting = org.autoreviewSettings
		? parseCodeReviewerSettingValue(org.autoreviewSettings?.value)
		: false;

	return (
		<CodeReviewerSettingToggle
			type="workspace"
			entityUrl={org.ownerUrl}
			setting={setting}
			disableToggle={false}
			onToggle={onToggle}
		/>
	);
};
